import { Hatch } from "../classes/Hatch";
import Utils, { isValidHttpUrl, matchImportUrl } from "../classes/Utils";

export class bigDropzone {
  selectedFile: File;
  progressEl: HTMLElement;
  req: XMLHttpRequest;
  private closed: boolean = true;
  private closeTimout: number;

  constructor() {
    document.querySelectorAll("#big-dropper [data-close]").forEach((el) => {
      el.addEventListener("click", (ev) => {
        this.close();
      });
    });

    window.addEventListener("keydown", (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        this.close();
      }
    });

    document.querySelector('#big-dropper [name="url"]').addEventListener("input", this.validateURL);

    document.querySelectorAll('#big-dropper button[type="submit"]').forEach((el) => {
      el.addEventListener("click", (ev) => {
        this.submit(ev);
      });
    });

    document.querySelector("#big-dropper-backdrop").addEventListener("click", (ev) => {
      this.close();
    });

    document.body.addEventListener("dragover", (ev) => {
      ev.preventDefault();

      if (ev.dataTransfer.types.includes("text/uri-list") || ev.dataTransfer.types.includes("Files")) {
        this.show();
      }
    });

    document.body.addEventListener("dragleave", (ev) => {
      if (!ev.relatedTarget) {
        ev.preventDefault();
        this.close();
      }
    });

    document.body.addEventListener("drop", (ev) => {
      ev.preventDefault();
      if (ev.dataTransfer.files[0]) {
        this.showFile(ev.dataTransfer.files);
      } else if (isValidHttpUrl(ev.dataTransfer.getData("text/plain"))) {
        this.showURL(ev.dataTransfer.getData("text/plain"));
      } else {
        this.close();

        globalThis.notification.notify({
          title: "Unable to select",
          message: "Nothing valid was dropped, please try dropping a file or http(s) url.",
          type: "info",
        });
      }
    });
    document.addEventListener("paste", async (ev) => {
      if (document.activeElement.tagName === "INPUT" || document.activeElement.tagName === "TEXTAREA") {
        return;
      }
      ev.preventDefault();
      const text = ev.clipboardData.getData("text/plain");
      const refang = Utils.refang(text);
      this.show();

      if (ev.clipboardData.files[0]) {
        this.showFile(ev.clipboardData.files);
      } else if (isValidHttpUrl(refang)) {
        this.showURL(refang);
      } else {
        this.close();

        globalThis.notification.notify({
          title: "Unable to select",
          message: "Nothing valid was dropped or pasted, please try dropping a file or http(s) url.",
          type: "info",
        });
      }
    });
  }

  showURL(str: string) {
    const urlInput = document.querySelector('#big-dropper-url [name="url"]') as HTMLInputElement;
    urlInput.value = str;
    urlInput.focus();
    this.validateURL();
    this.showSlide("url");
  }

  showFile(files: FileList) {
    this.selectedFile = files[0];

    if (files[0].size <= 4) {
      if (files[0].size <= 0) {
        globalThis.notification.notify({
          title: "Invalid sample",
          message: "File submissions can not be empty. This sample's file size is 0 bytes.",
          type: "danger",
        });
        return;
      } else {
        globalThis.notification.notify({
          title: "Invalid sample",
          message: "This sample size is below the minimum threshold to submit.",
          type: "danger",
        });
        return;
      }
    }

    let el = document.querySelector("#big-dropper");
    el.querySelector("#filename").innerHTML = Hatch`${files[0].name}`.toString();
    el.querySelector("#filesize").innerHTML = Hatch`${Utils.humanByteSize(files[0].size, 1).string}`.toString();
    el.querySelector("#filetype").innerHTML = Hatch`${files[0].type}`.toString();
    if (!files[0].type) {
      el.querySelector("#filetype").parentElement.classList.add("hidden");
    } else {
      el.querySelector("#filetype").parentElement.classList.remove("hidden");
    }

    (document.querySelector('#big-dropper-file [name="file"]') as HTMLInputElement).files = files;
    this.showSlide("file");
    document.querySelector<HTMLInputElement>("#big-dropper input[type=text]")?.focus();
  }

  showSlide(page: string) {
    let el = document.querySelector(`#big-dropper-${page}`);
    document.querySelectorAll("#big-dropper .tile").forEach((el) => el.classList.add("hidden"));
    el.classList.remove("hidden");
  }

  validateURL() {
    let url = (document.querySelector('#big-dropper [name="url"]') as HTMLInputElement)?.value;

    if (matchImportUrl(url)) {
      (document.querySelector("#big-dropper-url #url-dropper") as HTMLInputElement).disabled = true;
      (document.querySelector("#big-dropper-url #fetch-dropper") as HTMLInputElement).disabled = true;
      if (document.querySelector("#big-dropper-url #import-dropper")) {
        (document.querySelector("#big-dropper-url #import-dropper") as HTMLInputElement).disabled = false;
      }
    } else {
      (document.querySelector("#big-dropper-url #url-dropper") as HTMLInputElement).disabled = false;
      (document.querySelector("#big-dropper-url #fetch-dropper") as HTMLInputElement).disabled = false;
      if (document.querySelector("#big-dropper-url #import-dropper")) {
        (document.querySelector("#big-dropper-url #import-dropper") as HTMLInputElement).disabled = true;
      }
    }
  }

  show() {
    if (!this.closed) {
      return;
    }
    this.closed = false;
    clearTimeout(this.closeTimout);
    document.querySelector("#big-dropper").classList.remove("hidden");
    document.querySelectorAll("#big-dropper .tile").forEach((el) => el.classList.add("hidden"));
    document.querySelector(`#big-dropper-dropzone`).classList.remove("hidden");

    setTimeout(() => {
      document.querySelector("#big-dropper").classList.add("shown");
    }, 20);
  }

  close = () => {
    if (this.req) {
      this.req.abort();
    }
    if (this.closed) {
      return;
    }
    this.closed = true;
    document.querySelector("#big-dropper").classList.remove("shown");
    this.closeTimout = setTimeout(() => {
      document.querySelector("#big-dropper").classList.add("hidden");
    }, 300);
  };

  async submit(ev) {
    ev.preventDefault();
    this.progressEl = document.querySelector("#big-dropper-file .progress-bar");
    let form = ev.srcElement.closest("form");
    if (form.getAttribute("id") === "big-dropper-file") {
      ev.preventDefault();
      this.req = new XMLHttpRequest();
      let data = new FormData(form);
      this.req.onreadystatechange = () => {
        if (this.req.readyState != 4) {
          return;
        }
        if (this.req.responseURL) {
          globalThis.location.href = this.req.responseURL;
          return;
        }
        if (this.req.status >= 200 && this.req.status < 400) {
          return;
        }
        this.progressEl.classList.add("hidden");
        if (document.querySelector("#loader")) document.querySelector("#loader").classList.add("hidden");
        if (this.req.responseText)
          globalThis.notification.notify({
            title: this.req.status,
            message: this.req.response,
            type: "danger",
          });
      };
      this.req.addEventListener(
        "progress",
        (evt) => {
          onprogress(evt);
        },
        false
      );
      this.req.upload.addEventListener(
        "progress",
        (evt) => {
          onprogress(evt);
        },
        false
      );

      let onprogress = (evt) => {
        if (evt.lengthComputable) {
          let progress = (evt.loaded / evt.total) * 100;
          this.progressEl.classList.remove("hidden");
          this.progressEl.querySelector("progress").value = progress;
        }
      };

      this.req.open("POST", `${window.location.origin}/submit`);
      this.req.send(data);
    } else {
      if (ev.target.textContent === "Fetch") {
        form.querySelector('[name="url"]').setAttribute("name", "fetch");
      }
      if (ev.target.textContent === "Import") {
        form.querySelector('[name="url"]').setAttribute("name", "import");
      }
      form.submit();
    }
  }
}
